module.exports = __webpack_public_path__ + "img/icon-tip.453bac3e.svg";